import React from "react";
import {
  TextInput,
  ReferenceField,
  FunctionField,
  Edit,
  SimpleForm,
  NumberInput,
  List,
  Datagrid,
  TextField,
  Pagination,
  DateField,
  EditButton,
  DisabledInput
} from "react-admin";
import moment from "moment";
import styled from "styled-components";

const validateForm = values => {
  const errors = {};
  if (!values.kms_1) {
    errors.kms_1 = ["Km Begin is required"];
  }
  if (!values.kms_2) {
    errors.kms_2 = ["Km End is required"];
  }

  if (values.kms_1 && values.kms_2) {
    if (values.kms_1 > values.kms_2) {
      errors.kms_2 = ["Km End must be greather than Km End"];
    }
  }
  return errors;
};

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const rentalDays = tourVans => {
  const tour = tourVans.tour
  let days = moment().diff(moment(), 'days')
  if(tour != undefined)
    days = moment(tour.tour_end_date).diff(moment(tour.tour_start_date), 'days')
  return days
}

const StyledDiv = styled.div((props) => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px",
}));


export const UnenteredKmTourVansEdit = props => {
  return (
  <Edit title="Add Kms Tour Guide Van" {...props}>
    <SimpleForm validate={validateForm} redirect="/unentered_km_rentals">
      <DisabledInput label="Id" source="id" />
      <ReferenceField
        label="Tour"
        source="tour_id"
        reference="tours"
        linkType={false}
      >
        <ReferenceField
          source="tour_name_id"
          reference="tour_names"
          linkType={false}
        >
          <FunctionField
            render={tourName => {
              return `${tourName.tour_name_en} `;
            }}
          />
        </ReferenceField>
      </ReferenceField>

      <ReferenceField
        label="Date Begin"
        source="tour_id"
        reference="tours"
        linkType={false}
      >
        <FunctionField
          render={tour => {
            return `${moment(tour.tour_start_date).format("YYYY-MM-DD")} `;
          }}
        />
      </ReferenceField>

      <ReferenceField
        label="Date End"
        source="tour_id"
        reference="tours"
        linkType={false}
      >
        <FunctionField
          render={tour => {
            return `${moment(tour.tour_end_date).format("YYYY-MM-DD")} `;
          }}
        />
      </ReferenceField>

      <ReferenceField
        label="Vehicle"
        source="vehicle_id"
        reference="vehicles"
        linkType={true}
      >
        <FunctionField
          render={vehicle => {
            return `${vehicle.licence_plate} ${vehicle.renting ? "®" : ""}`;
          }}
        />
      </ReferenceField>
      <TextInput label="Km begin" source="kms_1" />
      <TextInput label="Km End" source="kms_2" />
    </SimpleForm>
  </Edit>
);}

export const UnenteredKmToursVansList = props => {
  return (
  <List {...props} pagination={<ListPagination />} bulkActionButtons={false} >
    <Datagrid>
      <FunctionField
        label="Bike"
        render={rental => {
          const model = rental.vehicle.model != undefined ? rental.vehicle.model.model_name : ''
         // console.log('\x1b[34m%s\x1b[0m', 'unenteredKmRentals.js line:116 rental', rental);
          return `${model}, ${rental.vehicle.licence_plate} ${rental.vehicle.renting ? "®" : ""}, ${rental.vehicle.vehicle_color != null ? rental.vehicle.vehicle_color : ""} ${rental.vehicle.vehicle_mileage}`;
        }}
      />
       <FunctionField
        label="Pick-up date"
        render={rental => {
          return rental.tour != undefined ?  moment(rental.tour.tour_start_date).format("DD-MM-YYYY") : ''
        }}
      />
         <FunctionField
        label="Drop-off date"
        render={rental => {
          return rental.tour != undefined ?  moment(rental.tour.tour_end_date).format("DD-MM-YYYY") : '';
        }}
      />

      <FunctionField
        label="Rental Type"
        render={rental => {
          return rental.type === 2 ? "Rental" : "Tour";
        }}
      />

      <FunctionField label="Tour Days" render={rentalDays} />

      <FunctionField
        label="Days Late"
        render={rental => {
          const day = rental.tour != undefined ? moment(rental.tour.tour_end_date) : ''
          return moment().diff(day, "days");
        }}
      />
      <EditButton label="ENTER" />
    </Datagrid>
  </List>
);
      }


// WEBPACK FOOTER //
// ./src/resources/unenteredKmTourVans.js